import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ResourceLink({ id, url, displayText, appTemplateView, }) {
    let link = url.indexOf("://") != -1 && url.substring(0, url.indexOf("://")) != null
        ? url
        : "http://" + url;
    return (_jsx("div", Object.assign({ className: "resource-link-component", id: "resource-link-" + id }, { children: _jsxs("a", Object.assign({ href: link, target: "_blank", className: "resource-link" }, { children: [_jsx("span", { children: displayText ? displayText : url }), " ", !appTemplateView && _jsx("span", { className: "mdi mdi-launch" })] })) })));
}
